// @ts-nocheck

export const LoginErrorCodes = Object.freeze({
  MAINTENANCE: -1,
  INVALID_EMAIL: 1,
  INVALID_PASSWORD: 2,
  ACCOUNT_NOT_ACTIVATED: 3,
  ACCOUNT_LOCKED: 4,
  ACCOUNT_SELF_EXCLUDED: 5,
  ACCOUNT_RESET: 6,
  INVALID_OLD_PASSWORD: 7,
  ACCOUNT_NOT_TRANSFERRED: 8,
  ACCOUNT_UNKNOWN_ERROR: 9,
  MANDATORY_FIELD: 11,
  INVALID_BIRTH_DATE: 12,
  SHOULD_BE_OVER18: 13,
  INVALID_TOKEN: 14,
  INCORRECT_BIRTH_DATE: 15,
  INVALID_LANGUAGE: 16,
  NEED_PINCODE: 17,
  INCORRECT_PINCODE: 18,
  PASSWORD_BLOCKED: 19,
  INVALID_BIOMETRIC_TOKEN: 20,
  IP_NOT_ALLOWED: 100,
});

export const BiometricTypes = Object.freeze({
  NONE: 0,
  TOUCHID: 1,
  FACEID: 2,
});
